import React from 'react';

import FileTypeDocument from '../filetypes/Document';
import FileTypeExcel from '../filetypes/Excel';
import FileTypeImage from '../filetypes/Image';
import FileTypePDF from '../filetypes/PDF';
import FileTypePowerPoint from '../filetypes/PowerPoint';
import FileTypeWord from '../filetypes/Word';

interface IOwnProps {
    mimeType: string;
}

type Props = IOwnProps;

class AttachmentIcon extends React.Component<Props, {}> {
    public render() {
        switch (this.props.mimeType) {
            case 'application/msword':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                return <FileTypeWord />;
            case 'application/vnd.ms-excel':
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                return <FileTypeExcel />;
            case 'application/vnd.ms-powerpoint':
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                return <FileTypePowerPoint />;
            case 'application/pdf':
                return <FileTypePDF />;
            case 'image/png':
            case 'image/gif':
            case 'image/jpeg':
            case 'image/bmp':
            case 'image/tiff':
            case 'image/webp':
                return <FileTypeImage />;
            default:
                return <FileTypeDocument />;
        }
    }
}

export default AttachmentIcon;